import { GET_MILES_SAVING_COUPONS_DATA } from "../../Actions/ActionConstants";

const MilesSavingCouponReducer = (state = null, action) => {
    if (action.type === GET_MILES_SAVING_COUPONS_DATA) {
        return action.data;
    } else {
        return state;
    }
};
export default MilesSavingCouponReducer